import React from 'react';
import cx from 'classnames';

import Input from './Input';

import { textarea, textareaNoResize } from '../styles.module.css';

const TextArea = ({ className, type, resizable, rows = 3, ...props }) => (
  <Input
    isTextArea
    rows={rows}
    className={cx(className, textarea, !resizable && textareaNoResize)}
    {...props}
  />
);

export default TextArea;
